import { useFormikContext } from "formik";
import { FormValues } from "../../../_shared/models/FormValues";
import { ProductDetails } from "../../../_shared/models/ProductDetails";

interface Props {
  selectedPlan: ProductDetails;
  planPrice: number;
  selectedAddons: ProductDetails[];
  addonsPrice: number;
}

const PaymentSummary = ({
  selectedPlan,
  planPrice,
  selectedAddons,
  addonsPrice,
}: Props) => {
  const { values } = useFormikContext<FormValues>();

  const newDate = new Date();
  const day = newDate.getDate();
  const nextMonth = ((newDate.getMonth() + 1) % 12) + 1;
  const year = newDate.getFullYear();

  return (
    // TODO: styling should be improved here
    <div>
      <div className="pay-summary">
        <p style={{ fontSize: "16px" }}>Summary:</p>
        <hr
          style={{
            margin: "5px auto",
            border: 0,
            height: 0,
            borderTop: "1px solid rgba(0, 0, 0, 0.1)",
            borderBottom: "1px solid rgba(255, 255, 255, 0.3)",
          }}
        />
        <ul>
          <li>
            <p>
              The{" "}
              <span style={{ color: "#75ce41", textTransform: "capitalize" }}>
                {values.plan.replace(/_/g, " ")}
              </span>{" "}
              includes {selectedPlan?.total_tickers} tickers updated{" "}
              <span style={{ color: "#75ce41" }}>{values.frequency}</span>
              &nbsp;for <span style={{ color: "#75ce41" }}>${planPrice}</span> a
              month.
            </p>
          </li>
          {values.addOns.length !== 0 ? (
            <div>
              <li>
                Add-On(s) included:
                <ul
                  data-testid="addons-list"
                  style={{ color: "#75ce41", whiteSpace: "pre-wrap" }}
                >
                  {selectedAddons.map((addon) => (
                    <li key={addon.key}>{addon.name}</li>
                  ))}
                  {values.plan === "master_plan" ? <li>Signal Alerts</li> : ""}
                </ul>
              </li>
              <li>
                Add-On(s) price total:{" "}
                <span style={{ color: "#75ce41" }}>
                  ${addonsPrice}
                  /month
                </span>
                .
              </li>
            </div>
          ) : (
            <div />
          )}
          {values.addOns.length !== 0 ? (
            <li>
              <p>
                The total billed today for your Longbow Plan
                {values.addOns.length !== 0 ? (
                  <span>&nbsp;and Add-On(s)</span>
                ) : (
                  ""
                )}
                &nbsp;will be&nbsp;
                <span style={{ color: "#75ce41" }}>
                  ${planPrice + addonsPrice}
                </span>
                .
              </p>
            </li>
          ) : (
            <div />
          )}
          <li>
            <p>
              Your next monthly payment will be processed on &nbsp;
              <span style={{ color: "#75ce41" }}>
                {nextMonth}/{day}/{year}
              </span>
              .
            </p>
          </li>
        </ul>
        <hr
          style={{
            margin: "5px auto",
            border: 0,
            height: 0,
            borderTop: "1px solid rgba(0, 0, 0, 0.1)",
            borderBottom: "1px solid rgba(255, 255, 255, 0.3)",
          }}
        />
      </div>
    </div>
  );
};

export default PaymentSummary;
